import { Button } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";
import { useFirstAndLastActivityLogs } from "../../data/queries/activityLogQueries";
import useModalEvent from "../../hooks/useModalEvent";
import { formatDateFromNow } from "../../utils/helpers";

export const CreatedByContainer = ({
  task,
  rolePermissions,
  canModifyTasks
}) => {
  const { ModalEvents, toggleModal } = useModalEvent();
  const { t, i18n } = useTranslation(["Overlay"], {
    useSuspense: false
  });

  const { data: activityLogs } = useFirstAndLastActivityLogs(task?.Id);

  const createdBy = activityLogs?.find((x) => x.Action === "Created");
  const lastModified = activityLogs?.find((x) => x.Action !== "Created");

  return (
    <div className="created-by-container et-bt-light-gray-1">
      {createdBy?.UserFullName && (
        <div className="px-4 py-3">
          <div className="et-darkest-gray">{t("CreatedBy")}</div>
          <div className="fs-14">
            {`${createdBy?.UserFullName} - ${formatDateFromNow(
              createdBy?.CreatedDate,
              i18n.language,
              "ll"
            )}`}
          </div>
        </div>
      )}

      {task?.Template && (
        <div className="px-4 py-3">
          <div className="et-darkest-gray">{t("CreatedWithTemplate")}</div>
          <div className="fs-14">{`${task?.Template?.Name} ${t(
            "ByExpertPractice"
          )}`}</div>
        </div>
      )}

      {lastModified?.UserFullName && (
        <div className="px-4 py-3">
          <div className="et-darkest-gray">{t("LastModified")}</div>
          <div className="fs-14">
            {`${lastModified?.UserFullName} - ${formatDateFromNow(
              lastModified?.CreatedDate,
              i18n.language,
              "ll"
            )}`}
          </div>
        </div>
      )}

      {rolePermissions?.CanDelete && canModifyTasks && (
        <div className="px-4 py-2">
          <Button
            text={t("DeleteTask")}
            className="btn btn-default w-auto et-dark-blue delete-task-btn"
            onClick={() => {
              toggleModal(ModalEvents.DeleteConfirmationModal, {
                name: task?.Name,
                client: task?.Client?.FullName,
                requestId: [task?.Id]
              });
            }}
            iconCss="fa-regular fa-trash-can et-black"
          />
        </div>
      )}
    </div>
  );
};
